<template>
  <div v-if="dialogVisible">
    <div style="display: flex;justify-content:space-evenly">
      <div style="width: 50%;margin-top: 100px;">
        <div style="margin-top: 10px;">
          添加参赛队伍
          <el-input v-model="userInfo.username.resultname" style="width: 150px;margin-right: 5px;"
            placeholder="填写大屏页队伍名" />
          <el-input v-model="userInfo.username.votename" style="width: 350px;margin-right: 5px;"
            placeholder="填写投票页队伍名" /><el-button type="primary" @click="addHandle">添加</el-button>
        </div>
        <el-divider />
        <div style="width: 900px;display: flex;">


          <div
            style="width: 75%;display: flex;flex-direction: column;align-items: center;margin-top: 4px;margin-left: 100px;">
            <div style="position: relative;width: 800px;margin-bottom: 10px;">
              <div style="font-weight: bolder;top: 0;bottom: 0;margin: auto;left: 70px; position: absolute;">
                大屏队伍名</div>
              <div style="top: 0;bottom: 0;margin: auto;margin-left: 150px; font-weight: bolder;">投票队伍名</div>
            </div>

            <div v-for="(item, index) in checkedCities" :key="index"
              style=" width:auto;height: 35px;line-height: 35px;margin-bottom: 5px;margin-left: 0px;margin-right: 0px;display: flex;">
              <div
                style="height: 35px;width: 200px; border: 1px solid black;border-radius: 5px;line-height: 35px;margin-bottom: 5px;margin-right: 10px;">
                {{ item.username.resultname }}
              </div>
              <div
                style="border: 1px solid black; height: 35px; width: 500px;margin-right: 10px;border-radius: 5px;display: flex;padding-left: 8px;line-height: 35px;">
                {{ (index
                  + 1) + '. ' +
                  item.username.votename }}</div>
              <el-popconfirm width="220" confirm-button-text="OK" cancel-button-text="No, Thanks" :icon="InfoFilled"
                icon-color="#626AEF" title="确认删除?" @confirm="deleteHandle(checkedCities[index])">
                <template #reference>
                  <!-- <el-button type="danger" @click="deleteHandle(checkedCities[index])">删除</el-button> -->
                  <el-button type="danger">删除</el-button>

                </template>

              </el-popconfirm>
              <el-button type="warning" @click="showDialogTableVisible(index)">修改</el-button>
              <el-dialog v-model="dialogTableVisible" title="参赛队伍修改" :close-on-click-modal="false" destroy-on-close
                @close="closeDialogTableVisible" width="800">
                <el-input v-model="editUserName.username.resultname" style="width: 150px;margin-right: 5px;"
                  placeholder="填写大屏页队伍名" />
                <el-input v-model="editUserName.username.votename" style="width: 350px;margin-right: 5px;"
                  placeholder="填写投票页队伍名" /><el-button type="primary" @click="editUserNameHandle">提交修改</el-button>
              </el-dialog>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 100px;">
        <div>
          配置每人可投票数
          <el-input v-model="config.select_number" style="width: 150px" placeholder="输入可投票数量" />
          <el-popconfirm width="220" confirm-button-text="OK" cancel-button-text="No, Thanks" :icon="InfoFilled"
            icon-color="#626AEF" title="确认修改?" @confirm="updateHandle">
            <template #reference>
              <el-button type="primary">修改</el-button>
            </template>

          </el-popconfirm>
        </div>

        <el-divider />
        <span>上传投票者信息</span>
        <!-- <el-upload v-model:file-list="fileList" class="upload-demo"
          action="https://result.aigcute.com/backend-api/upload" multiple -->
        <el-upload v-model:file-list="fileList" class="upload-demo" action="http://localhost:5001/upload" multiple
          @preview="handlePreview" @remove="handleRemove" @before-remove="beforeRemove" :limit="3"
          @exceed="handleExceed" @success="uploadSuccess" accept=".xls,.xlsx" @before-upload="beforeUpload"
          :on-change="handleChange">
          <el-button type="primary">上传excel文件</el-button>
        </el-upload>
        <el-popconfirm width="220" confirm-button-text="OK" cancel-button-text="No, Thanks" :icon="InfoFilled"
          icon-color="#626AEF" title="确认清空?" @confirm="deleteAllParticipants">
          <template #reference>
            <el-button type="danger"> 清空投票者数据库数据 </el-button>
          </template>
        </el-popconfirm>
        <el-divider />
        <div style="display: flex;flex-direction: column;align-items: center;">
          <div>设置投票规则</div>
          <el-input v-model="config.textarea" style="width: 240px;margin-top: 5px;" :rows="10" type="textarea"
            placeholder="输入投票规则" />
          <el-popconfirm width="220" confirm-button-text="OK" cancel-button-text="No, Thanks" :icon="InfoFilled"
            icon-color="#626AEF" title="确认修改?" @confirm="updateHandle">
            <template #reference>
              <el-button type="primary" style="margin-top: 5px;width: 80px;">确定</el-button>
            </template>
          </el-popconfirm>
        </div>

      </div>
    </div>
    <a href="weixin://dl/business/?appid=wx8d400dcb305fadce&path=pages/index/index&query=channel=douyin">打开微信小程序</a>
  </div>
  <div v-if="!dialogVisible" style="margin-top: 200px;">输入密码<el-input
      style="width: 150px;margin-left: 10px;margin-right: 5px;" v-model="password" type="password"></el-input>
    <el-button type="primary" @click="checkPassword">
      确定
    </el-button>
  </div>


</template>

<script>
import { ref, onMounted } from "vue";
import User from '@/utils/user'
import Participant from '@/utils/participant'
import Config from '@/utils/config'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ElLoading } from 'element-plus'
export default {
  name: "Toupiao",
  setup() {
    const checkedCities = ref([]);
    const userInfo = ref({ username: { votename: '', resultname: '' }, quantity: 0 });
    const editUserName = ref({ username: { votename: '', resultname: '' }, quantity: 0 })
    const config = ref({ select_number: 0, textarea: '' })
    let loading = null
    const dialogVisible = ref(false)
    const dialogTableVisible = ref(false)
    const password = ref('')
    const addHandle = async () => {
      console.log('checkedCities', userInfo.value)
      //userInfo.value.username = '{"votename":' + userInfo.value.username.votename + ',"resultname":' + userInfo.value.username.resultname + '}'
      await User.create({ username: '{"votename":"' + userInfo.value.username.votename + '","resultname":"' + userInfo.value.username.resultname + '"}', quantity: 0 }
      );
      userInfo.value.username.votename = ''
      userInfo.value.username.resultname = ''
      getUserList();
    };
    const deleteHandle = async (item) => {
      console.log("id", item.id)
      await User._delete(Number(item.id));
      getUserList();
    }

    const updateHandle = async () => {
      console.log('updateHandle', config.value)
      await Config.update(config.value);
      getConfig();
    }

    const deleteAllParticipants = async () => {
      let res = await Participant.deleteAll();
      if (res.data.code === 200) {
        ElMessage({
          message: '删除成功',
          type: 'success',
        })
      }
    }

    const openFullScreen = () => {
      loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
    }

    const checkPassword = () => {
      console.log('checkPassword', password.value)
      if (password.value === 'vote123456') {
        dialogVisible.value = true
      } else {
        ElMessage({
          message: '密码错误',
          type: 'error',
        })
      }
    }


    const beforeUpload = (file) => {
      console.log('beforeUpload', file)
      const isType = file.type === 'application/vnd.ms-excel'
      const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const fileType = isType || isTypeComputer
      if (!fileType) {
        //this.$message.error('上传文件只能是xls/xlsx格式！')
      }
      const fileLimit = file.size / 1024 / 1024 < 10;
      if (!fileLimit) {
        //this.$message.error('上传文件大小不超过10M！');
      }
      return fileType && fileLimit
    }

    //handleChange函数处理on-change事件
    const handleChange = (file, fileList) => {
      console.log('handleChange', file, fileList)
      //status为ready时 显示加载框
      if (file.status === 'ready') {
        openFullScreen()
      }
    }

    const editUserNameHandle = async () => {
      // await User.put(JSON.parse(JSON.stringify(editUserName.value)))
      let res = await User.put({ username: '{"votename":"' + editUserName.value.username.votename + '","resultname":"' + editUserName.value.username.resultname + '"}', id: editUserName.value.id, quantity: 0 })
      dialogTableVisible.value = false
      console.log('editUserNameHandle', res)
      if (res.data.code === 200) {
        ElMessage({
          message: '修改成功',
          type: 'success',
        })
        getUserList();
      } else {
        ElMessage({
          message: '修改失败',
          type: 'error',
        })
      }
    }

    const fileList = ref([])

    const handleRemove = (file, uploadFiles) => {
      console.log(file, uploadFiles)
    }

    const uploadSuccess = async (response, uploadFile, uploadFiles) => {
      if (loading) {
        loading.close();

      }
      if (response.code == 200) {
        ElMessage({
          message: '上传成功' + response.data.quantity + "条信息",
          type: 'success',
        })
      } else if (response.code == 503) {
        ElMessage({
          message: response.data.data,
          type: 'error',
        })
      } else {
        ElMessage({
          message: '上传失败',
          type: 'error',
        })
      }
      console.log(response)
    }

    const handlePreview = (uploadFile) => {
      console.log(uploadFile)
    }

    const handleExceed = (files, uploadFiles) => {
      ElMessage.warning(
        `The limit is 3, you selected ${files.length} files this time, add up to ${files.length + uploadFiles.length} totally`
      )
    }

    const beforeRemove = (uploadFile, uploadFiles) => {
      return ElMessageBox.confirm(
        `Cancel the transfer of ${uploadFile.name} ?`
      ).then(
        () => true,
        () => false
      )
    }

    const showDialogTableVisible = (index) => {
      dialogTableVisible.value = true;
      editUserName.value.username.votename = checkedCities.value[index].username.votename
      editUserName.value.username.resultname = checkedCities.value[index].username.resultname
      editUserName.value.id = checkedCities.value[index].id
      editUserName.value.quantity = checkedCities.value[index].quantity

      console.log('修改', checkedCities.value[index], editUserName.value)
    }

    const closeDialogTableVisible = () => {
      dialogTableVisible.value = false;
    }



    onMounted(() => {
      // 这里的代码会在组件挂载到 DOM 后执行  
      console.log('Component is mounted!');
      getUserList();
      getConfig();
    });

    const getUserList = async () => {
      let res = await User.getAll();
      for (let item of res.data.data) {
        item.username = JSON.parse(item.username);
      }
      // console.log("getUserList", JSON.parse(res.data.data[0].username), res.data.data);
      console.log("getUserList", res.data);

      checkedCities.value = res.data.data;
    };

    const getConfig = async () => {
      let res = await Config.getConfig();
      console.log('getConfig', res)
      config.value.select_number = Number(res.data.data.data.select_number)
      config.value.textarea = res.data.data.data.textarea

    };


    return {
      checkedCities,
      addHandle,
      deleteHandle,
      userInfo,
      config,
      updateHandle,
      fileList,
      handleRemove,
      handlePreview,
      handleExceed,
      beforeRemove,
      beforeUpload,
      uploadSuccess,
      openFullScreen,
      handleChange,
      deleteAllParticipants,
      dialogVisible,
      checkPassword,
      password,
      dialogTableVisible,
      showDialogTableVisible,
      closeDialogTableVisible,
      editUserName,
      editUserNameHandle
    };
  },
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
